// Auto-generated file: Do not modify directly. Changes may be overwritten. Version: 1.2.0.

/*
 * Following tokens have been deprecated in version 1.2.0, please update your theme:
 *
 * Interactive/Focus has been split into two separate tokens. Please define 'Interactive/Focus Inner' and 'Interactive/Focus Outer' instead.
 * 'Interactive/Background Default' is deprecated. Please use 'Input/Background Default' instead.
 * 'Interactive/Background Disabled' is deprecated. Please use 'Input/Background Disabled' instead.
 * 'Interactive/Background Hovered' is deprecated. Please use 'Input/Background Hovered' instead.
 * 'Interactive/Background Pressed' is deprecated. Please use 'Input/Background Pressed' instead.
 * 'Interactive/Border Default' is deprecated. Please use 'Input/Border Default' instead.
 * 'Interactive/Border Hovered' is deprecated. Please use 'Input/Border Hovered' instead.
 * 'Interactive/Border Disabled' is deprecated. Please use 'Input/Border Disabled' instead.
 * 'Interactive/Border Critical Default' is deprecated. Please use 'Input/Border Critical' instead.
 * 'Pill' is deprecated. Please use 'Circle' instead.
 */

import type { GDSTheme } from '@leagueplatform/genesis-core';

export const ovatientTheme: GDSTheme = {
  colors: {
    surface: {
      background: {
        primary: '#FFFFFFFF',
        secondary: '#F8F8F8FF',
        tertiary: '#EAF5FFFF',
      },
      card: {
        primary: '#F8F8F8FF',
        secondary: '#FFFFFFFF',
        disabled: '#EBEBEBFF',
      },
      screenHeader: { background: '#ACD7FFFF' },
      skeleton: {
        shimmer: {
          background: '#E7E7E7FF',
          overlay:
            'linear-gradient(90.0deg, #FFFFFF00 0%, #FFFFFF80 50%, #FFFFFFE5 70%, #FFFFFF00 100%)',
        },
      },
    },
    onSurface: {
      text: {
        primary: '#333333FF',
        subdued: '#737171FF',
        reversed: '#FFFFFFFF',
        critical: '#CC0A17FF',
        success: '#197817FF',
        warning: '#C26710FF',
      },
      border: { subdued: '#CECECEFF', default: '#959595FF', card: '#CECECEFF' },
      icon: { primary: '#636363FF' },
    },
    interactive: {
      action: {
        primary: '#025AA7FF',
        hovered: '#004784FF',
        pressed: '#184C7AFF',
        subdued: '#66686BFF',
        disabled: '#D6D6D6FF',
      },
      icon: { default: '#FFFFFFFF', disabled: '#949494FF' },
      background: {
        default: '#FFFFFFFF',
        disabled: '#E8EAEDFF',
        hovered: '#F8F8F8FF',
        pressed: '#F0F0F0FF',
      },
      border: {
        default: '#949494FF',
        hovered: '#025AA7FF',
        disabled: '#D6D6D6FF',
        critical: { default: '#CC0A17FF' },
      },
      focus: { inner: '#025AA7FF', outer: '#025AA7FF' },
    },
    critical: {
      background: { subdued: '#F3BAB8FF', secondary: '#FFFFFFFF' },
      border: { default: '#CC0A17FF' },
      icon: '#CC0A17FF',
    },
    warning: {
      background: { subdued: '#F8CCA2FF', secondary: '#FFFFFFFF' },
      border: { default: '#C26710FF' },
      icon: '#C26710FF',
    },
    success: {
      background: { subdued: '#B2EDB0FF', secondary: '#FFFFFFFF' },
      border: { default: '#197817FF' },
      icon: '#197817FF',
    },
    highlight: {
      background: { subdued: '#EFCEE2FF', secondary: '#FFFFFFFF' },
      border: { default: '#902683FF' },
      icon: '#902683FF',
    },
    decorative: {
      brand: {
        primary: {
          darkest: '#003666FF',
          dark: '#024784FF',
          default: '#025AA7FF',
          bright: '#59A6E9FF',
          brightest: '#ACD7FFFF',
          pastel: '#D4EBFFFF',
        },
        secondary: {
          darkest: '#003666FF',
          dark: '#024784FF',
          default: '#025AA7FF',
          bright: '#59A6E9FF',
          brightest: '#ACD7FFFF',
          pastel: '#D4EBFFFF',
        },
        tertiary: {
          darkest: '#01544DFF',
          dark: '#008277FF',
          default: '#00AB9DFF',
          bright: '#3DEBDDFF',
          brightest: '#70FAEEFF',
          pastel: '#B1F6F1FF',
        },
      },
    },
    primary: {
      background: {
        default: '#025AA7FF',
        hovered: '#004784FF',
        pressed: '#184C7AFF',
        critical: {
          default: '#CC0A17FF',
          hovered: '#DE1B28FF',
          pressed: '#9B0711FF',
        },
      },
      text: { default: '#FFFFFFFF', critical: { default: '#FFFFFFFF' } },
    },
    secondary: {
      background: {
        default: '#FFFFFF00',
        hovered: '#005DACFF',
        pressed: '#005DACFF',
      },
      text: { default: '#005DACFF', hovered: '#FFFFFFFF' },
      border: { default: '#005DACFF' },
    },
    tertiary: {
      background: {
        default: '#FFFFFF00',
        hovered: '#005DACFF',
        pressed: '#005DACFF',
      },
      text: { default: '#005DACFF', hovered: '#FFFFFFFF' },
      border: { default: '#707E89FF' },
    },
    input: {
      border: {
        success: '#2A8E28FF',
        warning: '#C26710FF',
        default: '#949494FF',
        hovered: '#025AA7FF',
        disabled: '#D6D6D6FF',
        critical: '#CC0A17FF',
      },
      background: {
        default: '#FFFFFFFF',
        disabled: '#E8EAEDFF',
        hovered: '#F8F8F8FF',
        pressed: '#F0F0F0FF',
      },
    },
    dataViz: {
      interface: { track: { border: '#8A8A8AFF', background: '#EFEFEFFF' } },
      singleColor: { brand: '#025AA7FF', neutral: '#8A8A8AFF' },
      status: {
        critical: '#EC2027FF',
        warning: '#F28521FF',
        success: '#2A8E28FF',
      },
      categorical: {
        one: '#025AA7FF',
        two: '#59A6E9FF',
        three: '#632D80FF',
        four: '#E60B8AFF',
        five: '#F28521FF',
        six: '#4CB549FF',
      },
    },
  },
  shadows: {
    card: { x: 0, y: 2, blur: 6, spread: 0, color: '#00000033' },
    dropdown: { x: 0, y: 4, blur: 8, spread: 0, color: '#00000033' },
  },
  typography: {
    headingOne: {
      fontFamily: 'Montsterrat SemiBold',
      fontWeight: 600,
      lineHeight: 40,
      fontSize: 32,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    headingTwo: {
      fontFamily: 'Montsterrat SemiBold',
      fontWeight: 600,
      lineHeight: 32,
      fontSize: 24,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    headingThree: {
      fontFamily: 'Montsterrat SemiBold',
      fontWeight: 600,
      lineHeight: 28,
      fontSize: 20,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    headingFour: {
      fontFamily: 'Montsterrat SemiBold',
      fontWeight: 600,
      lineHeight: 24,
      fontSize: 18,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    subtitleOne: {
      fontFamily: 'Montsterrat SemiBold',
      fontWeight: 600,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    subtitleTwo: {
      fontFamily: 'Montsterrat SemiBold',
      fontWeight: 600,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    bodyOne: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: 'none',
      textDecoration: 'none',
    },
    bodyOneSecondary: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: 'none',
      textDecoration: 'none',
    },
    bodyTwo: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: 'none',
      textDecoration: 'none',
    },
    bodyTwoSecondary: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: 'none',
      textDecoration: 'none',
    },
    buttonOne: {
      fontFamily: 'Montsterrat SemiBold',
      fontWeight: 600,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    buttonTwo: {
      fontFamily: 'Montsterrat SemiBold',
      fontWeight: 600,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    label: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 500,
      lineHeight: 16,
      fontSize: 12,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    overline: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 700,
      lineHeight: 16,
      fontSize: 12,
      letterSpacing: 0.6000000238418579,
      paragraphSpacing: 0,
      textCase: 'uppercase',
      textDecoration: 'none',
    },
    caption: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 16,
      fontSize: 12,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    tab: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 12,
      fontSize: 10,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
  },
  spacing: {
    none: 0,
    quarter: 4,
    half: 8,
    threeQuarters: 12,
    one: 16,
    oneAndHalf: 24,
    two: 32,
    twoAndHalf: 40,
    three: 48,
    four: 64,
    five: 80,
  },
  borderWidths: { thin: 1, thick: 2, outerFocus: 3, innerFocus: 3, card: 1 },
  borderRadii: {
    none: 0,
    thin: 1,
    thick: 2,
    small: 3,
    medium: 6,
    large: 9,
    extraLarge: 12,
    huge: 20,
    circle: 99999,
    pill: 99999,
    button: 99999,
    inputField: 6,
    card: 6,
  },
  zIndices: {
    default: 1,
    sticky: 100,
    dropdown: 4000,
    tooltip: 5000,
    modal: 8000,
    toast: 9000,
  },
  rem: {
    fontSizes: {
      headingOne: 2,
      headingTwo: 1.5,
      headingThree: 1.25,
      headingFour: 1.125,
      subtitleOne: 1,
      subtitleTwo: 0.875,
      bodyOne: 1,
      bodyOneSecondary: 1,
      bodyTwo: 0.875,
      bodyTwoSecondary: 0.875,
      buttonOne: 1,
      buttonTwo: 0.875,
      label: 0.75,
      overline: 0.75,
      caption: 0.75,
      tab: 0.625,
    },
    lineHeights: {
      headingOne: 2.5,
      headingTwo: 2,
      headingThree: 1.75,
      headingFour: 1.5,
      subtitleOne: 1.5,
      subtitleTwo: 1.25,
      bodyOne: 1.5,
      bodyOneSecondary: 1.5,
      bodyTwo: 1.25,
      bodyTwoSecondary: 1.25,
      buttonOne: 1.5,
      buttonTwo: 1.25,
      label: 1,
      overline: 1,
      caption: 1,
      tab: 0.75,
    },
    baseSize: 16,
  },
  fonts: {
    headings: 'Montsterrat SemiBold',
    body: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
  },
  transitions: { defaultTime: '200ms' },
};
